export default "__VITE_ASSET__684d9b7d__"